import BaseController       from "controllers/external/project/base";
import InspectionListWidget from "widgets/inspection/inspectionsListWidget";
import ChecklistCarousel    from "widgets/project/checklistCarousel";
import ChecklistCompleteWidget from "../../../../widgets/project/checklistComplete";
import InlineDocumentUpload from "widgets/checklistItem/inlineDocumentUpload";
import AddComplaint         from 'widgets/project/AddComplaint';
import RemoveDocumentWidget       from "widgets/checklistItem/removeDocumentWidget";

class Controller extends BaseController {
  call() {
    setActiveTab.call(this);
    this.inspectionListWidget = new InspectionListWidget(this.root, '#inspection-modal-container', '#inspections-tab');
    this.checklistInspectionListWidget = new InspectionListWidget(this.root, '#checklist-inspection-modal-container', '#checklists-main-tab');

    this.inspectionListWidget.on('form-loaded', (e) => {
      this.bindInputComponents();
    })

    this.inspectionListWidget.on('item-updated', (e) => {
      bindToggleNote.call(this);
    })

    this.checklistInspectionListWidget.on('form-loaded', (e) => {
      this.bindInputComponents();
    })

    this.checklistInspectionListWidget.on('item-updated', (e) => {
      bindToggleNote.call(this);
    })

    bindToggleNote.call(this);

    new ChecklistCarousel(this.root);
    // this.DocumentUploadWidget = new DocumentUploadWidget(this.root);
    // this.DocumentUploadWidget.on('form-loaded', (e) => {
    //   this.bindInputComponents()
    // })

    bindShowComplaint.call(this)
    bindViewDocument.call(this)
    this.AddComplaintWidget = new AddComplaint(this.root.find('#new-complaint'));
    this.RemoveDocumentWidget = new RemoveDocumentWidget(this.root);

    bindInlineUploadDocumentForms.call(this)
    disableInspectionButton.call(this);
    new ChecklistCompleteWidget(this.root);
  }
}

let disableInspectionButton = function () {
  const slideCount = $("#slick-checklist-slider .checklist-slider").length;
  if (slideCount <= 2) {
    $(this.root.find('.inspection-tab')).addClass("disable-list-item");
  }
}

const bindInlineUploadDocumentForms = function() {
  _.each(this.root.find('.checklist-item'), (item) => {
    new InlineDocumentUpload($(item))
  })
}

let setActiveTab = function() {
  let activeTab = gon.project
  const bootstrap = window.bootstrap;
  const el = document.querySelector(`ul.proj-nav a[href="#${activeTab["active_tab"]}"]`);
  if (bootstrap && el) new bootstrap.Tab(el).show();
}

let bindToggleNote = function() {
  const bootstrap = window.bootstrap;
  if (!bootstrap) return;

  document.querySelectorAll('.note[data-bs-toggle="popover"]').forEach((el) => {
    new bootstrap.Popover(el, { trigger: 'hover' });
  });
}

let bindShowComplaint = function() {
  $('.complaint-item').on('click', (e) => {
    let complaintUrl = `${gon.base_namespace}/complaints/${e.currentTarget.dataset.complaintId}`
    $.ajax({
      url: complaintUrl,
      type: "GET",
      dataType: 'json',
      success: (data) => {
        $('#complaint-modal-container').html(data.html);
        const bootstrap = window.bootstrap;
        const modalEl = document.querySelector('#complaint-modal-container .modal');
        if (bootstrap && modalEl) new bootstrap.Modal(modalEl).show();
      }
    });
  });
}

// Shared across every checklist item's document row on both external pages (account portal and
// project portal) — the button's data-url always points at the external/project-scoped route
// (see _document.slim), so one handler + one modal partial covers both entry points.
let bindViewDocument = function() {
  this.root.on('click', '.view-document-external', (e) => {
    e.preventDefault();
    $.ajax({
      url: e.currentTarget.dataset.url,
      type: "GET",
      dataType: 'json',
      success: (data) => {
        $('#checklist-modal-container').html(data.html);
        const bootstrap = window.bootstrap;
        const modalEl = document.querySelector('#checklist-modal-container .modal');
        if (bootstrap && modalEl) new bootstrap.Modal(modalEl).show();
      }
    });
  });
}



export default Controller;
